export const mostLiked = [
  "Easy to use",
  "Video/audio calls",
  "Security",
  " Privacy",
  "Smart search filters",
  " Accurate matches",
  "Personalized recommendations",
];
